/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const walletEventSchema = z.enum(['credited', 'debited', 'held', 'settled', 'released'])

export type WalletEventSchema = z.infer<typeof walletEventSchema>
